import waRequest from './wa-request';

export const baseApi = '/support/v1';

function submitAccessAnalystRequest(configData) {
  const {data} = configData;

  const url = `${baseApi}/support-requests/access-analyst`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'post',
    data,
  });
}

function submitNewLocationRequest(configData) {
  const {data} = configData;

  const url = `${baseApi}/support-requests/add-location`;

  return waRequest.requestAuthenticated({
    url: url,
    method: 'post',
    data,
  });
}

export default {
  submitAccessAnalystRequest,
  submitNewLocationRequest,
};
